
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm fixed w-full top-0 z-50">
      {/* Logo Fachada - Full Width */}
      <div className="w-full bg-gradient-to-r from-orange-50 to-orange-100 py-4 border-b border-orange-200">
        <div className="container mx-auto px-4">
          <img 
            src="https://static.readdy.ai/image/b69cde7a13f4ad572f616ac3fb1754b6/e1e201c965bd79027b63ff9b024ed493.png" 
            alt="PRIMECONDOMINIALSOLUCOES Logo" 
            className="h-24 w-full object-contain cursor-pointer"
            onClick={() => scrollToSection('inicio')}
          />
        </div>
      </div>

      {/* Navigation Bar */}
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <nav className="hidden md:flex items-center space-x-8 mx-auto">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer whitespace-nowrap font-medium"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('servicos')}
              className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer whitespace-nowrap font-medium"
            >
              Serviços
            </button>
            <button 
              onClick={() => scrollToSection('sobre')}
              className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer whitespace-nowrap font-medium"
            >
              Sobre Nós
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="bg-orange-600 text-white px-6 py-2 rounded-full hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contato
            </button>
          </nav>

          <button 
            className="md:hidden cursor-pointer mx-auto"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className="ri-menu-line text-2xl text-gray-700"></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4 pt-4">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer text-center font-medium"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('servicos')}
                className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer text-center font-medium"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('sobre')}
                className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer text-center font-medium"
              >
                Sobre Nós
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="bg-orange-600 text-white px-6 py-2 rounded-full hover:bg-orange-700 transition-colors cursor-pointer mx-auto"
              >
                Contato
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
